import React from 'react';

export default function RequiredAsterisk(): JSX.Element {
  return (
    <span
      style={{
        color: '#ff0000',
      }}
    >
      *
    </span>
  );
}
